import React from "react";
import {
  ScrollView,
  TouchableOpacity,
  TouchableWithoutFeedback,
  StyleSheet,
  Text,
  View,
  Modal,
  FlatList,
  TextInput,
  Image,
  Dimensions,
  Platform,
} from "react-native";
import { Amplify, Auth } from "aws-amplify";
// import awsConfig from "./aws-exports";
import getEnvVars from "../../enviroment";
import { useNavigation } from "@react-navigation/native";
import { Ionicons } from "@expo/vector-icons";
import GlobalStyles from "../../components/GlobalStyles";
import IntlPhoneInput from "react-native-intl-phone-input";
import PhoneInput from "react-native-phone-number-input";
import { AntDesign } from "@expo/vector-icons";
let platform = Platform.OS;

const awsConfig = getEnvVars().awsConfig;

Amplify.configure(awsConfig);

function create_UUID() {
  var dt = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

export default function SignUp(props) {
  const sparkle = require("../../assets/res/sparkle.png");
  const [username, onChangeUserText] = React.useState("");
  const [password, onChangePassText] = React.useState("");
  const [email, onChangeEmailText] = React.useState("");
  const [phone, onChangePhoneText] = React.useState("");
  const [value, setValue] = React.useState("");
  const [valueCode, setValueCode] = React.useState("61");
  const [givenName, onChangeGivenNameText] = React.useState("");
  const [familyName, onChangeFamilyNameText] = React.useState("");
  const [authCode, onChangeAuthCodeText] = React.useState("");
  var [refId, onChangeRefIDText] = React.useState("");
  const win = Dimensions.get("window");
  const [step, onChangeStep] = React.useState(0);

  const [showHidePassword, onChangePasswordShow] = React.useState(true);

  const [errorMsg, onErrorMsg] = React.useState("");

  const navigation = useNavigation();

  //  refId = "";
  //if (Platform.OS === "web") {
  // var parsedUrl = new URL(window.location.href);
  // refId = parsedUrl.searchParams.get("refId");
  //}

  var formMode = "";
  if (typeof props.mode !== undefined) {
    formMode = props.mode;
  }
  const trySignUp = async (mode, password, email, givenN, familyN, phone, refererId) => {
    try {
      var un = "";
      if (mode === "p" && phone !== "") {
        un = phone;
      } else if (mode === "e" && email !== "") un = email;
      else {
        onErrorMsg("Phone or Email Required");
        return;
      }

      var attri = {
        given_name: givenN,
        family_name: familyN,
        'custom:refererId': refererId
      };
      if (mode === "p") {
        attri.phone_number = un;
        attri.email = "";
      } else if (mode === "e") {
        attri.phone_number = "";
        attri.email = un;
      }
      // console.log(un);
      const res = await Auth.signUp({
        username: un,
        password: password,
        attributes: attri,
      });
      onChangeStep(2);
    } catch (error) {
      onErrorMsg(error.message);
    }
  };

  const confirmSignUp = async (username, authCode, formMode) => {
    const memberGUID = create_UUID();
    const userobj = {
      memberId: create_UUID(),
      referFriendId: "0",
      refererId: "0",
      givenName: givenName,
      familyName: familyName,
      phone: phone,
      email: email,
    };
    try {
      await Auth.confirmSignUp(username, authCode);
      // console.log("user successfully signed up");
      navigation.navigate("Login", { formMode: formMode });
    } catch (error) {
      onErrorMsg(error.message);
    }
  };

  var phoneInput;

  var renderCustomModal = (modalVisible, countries, onCountryChange) => (
    <Modal visible={modalVisible}>
      <View style={styles.phoneModalContainer}>
        <TouchableOpacity
          onPress={() => phoneInput.hideModal()}
          style={styles.phoneModalClose}
        >
          <Ionicons
            name="md-arrow-back"
            size={20}
            style={styles.HbackArrowBlack}
          />
        </TouchableOpacity>
        <View style={styles.phoneModalInputContainer}>
          <View style={styles.phoneModalListItemFlag}>
            <Ionicons
              name="md-search"
              size={24}
              style={styles.phoneModalIcon}
            />
          </View>
          <View style={styles.phoneModalListItemCountry}>
            <TextInput
              onChangeText={(v) => phoneInput.filterCountries(v)}
              placeholder="Country Filter"
              style={styles.phoneModalInputField}
            />
          </View>
          <View style={styles.phoneModalListItemDailcode}></View>
        </View>
        <FlatList
          style={styles.phoneModalList}
          data={countries}
          keyExtractor={(item, index) => index.toString()}
          renderItem={({ item }) => (
            <TouchableWithoutFeedback
              onPress={() => onCountryChange(item.code)}
            >
              <View style={styles.phoneModalListItem}>
                <View style={styles.phoneModalListItemFlag}>
                  <Text style={styles.phoneModalListIemFlagText}>
                    {item["flag"]}
                  </Text>
                </View>
                <View style={styles.phoneModalListItemCountry}>
                  <Text style={styles.phoneModalListIemText}>{item["en"]}</Text>
                </View>
                <View style={styles.phoneModalListItemDailcode}>
                  <Text style={styles.phoneModalListIemText}>
                    {item["dialCode"]}
                  </Text>
                </View>
              </View>
            </TouchableWithoutFeedback>
          )}
        />
      </View>
    </Modal>
  );
  return (
    <View style={styles.containerOne}>
      {step === 0 ? (
        <>
        <ScrollView>
          <View style={styles.padThirty}>
            <View style={styles.HbuttonBar}>
              <TouchableOpacity
                style={styles.HbackButtonStyle}
                onPress={() => navigation.goBack()}
              >
                <Ionicons
                  name="md-arrow-back"
                  size={20}
                  style={styles.HbackArrow}
                />
              </TouchableOpacity>
              <View>
                <Text style={styles.HTextStyle}>REGISTER</Text>
              </View>
              <TouchableOpacity
              style={styles.HbackButtonStyle}
              onPress={() => {
              var myphone = "";
              var un = "";
              if (platform === "web") {
                un = value;
                if (un.charAt(0) == '0') un = un.substring(1);
                un = "+" + valueCode + un;
              } else {
                un = phone.unmaskedPhoneNumber;
                if (un != undefined) {
                  if (un.charAt(0) == "0") un = un.substring(1);
                  un = phone.dialCode.concat(un);  
                } else {
                  un = "";
                }
              }
              var myphone = un;
                trySignUp(
                  formMode,
                  password,
                  email,
                  givenName,
                  familyName,
                  myphone,
                  refId
                );
              }}
            >
              <Text style={styles.TextStyleRight}>NEXT</Text>
              <View style={styles.LinkBarNext}></View>
            </TouchableOpacity>
            </View>

            <View style={styles.infoBox}>
              {/* username section  */}
              {/* <View style={styles.inputContainer}>
              <TextInput
                style={styles.textInput}
                placeholder="Username"
                placeholderTextColor="#adb4bc"
                autoCapitalize="none"
                value={username}
                onChangeText={(text) => onChangeUserText(text)}
              />
            </View> */}
              {/* first name section */}
              <View style={styles.inputContainer}>
                <TextInput
                  style={styles.textInput}
                  placeholder="First Name"
                  placeholderTextColor="#adb4bc"
                  returnKeyType="next"
                  autoCapitalize="none"
                  autoCorrect={false}
                  secureTextEntry={false}
                  value={givenName}
                  onChangeText={(text) => onChangeGivenNameText(text)}
                />
              </View>
              {/* second name section */}
              <View style={styles.inputContainer}>
                <TextInput
                  style={styles.textInput}
                  placeholder="Last Name"
                  placeholderTextColor="#adb4bc"
                  returnKeyType="next"
                  autoCapitalize="none"
                  autoCorrect={false}
                  secureTextEntry={false}
                  value={familyName}
                  onChangeText={(text) => onChangeFamilyNameText(text)}
                />
              </View>
              {formMode === "e" ? (
                /* email section */
                <View style={styles.inputContainer}>
                  <TextInput
                    style={styles.textInput}
                    placeholder="Email"
                    placeholderTextColor="#adb4bc"
                    keyboardType={"email-address"}
                    returnKeyType="next"
                    autoCapitalize="none"
                    autoCorrect={false}
                    secureTextEntry={false}
                    value={email}
                    onChangeText={(text) => onChangeEmailText(text)}
                    dialCodeTextStyle={styles.textInput}
                  />
                </View>
              ) : (
                  <></>
                )}
              {formMode === "p" ? (
                /* phone section  */
                <View style={styles.inputContainer}>
                  <View style={styles.textInputNoUnderline}>
                    {platform === "web" ? (
                      <View style={styles.flexStyle}>
                        <Text style={styles.formLabelStyle}>Phone</Text>
                        <PhoneInput
                          defaultCode={"AU"}
                          value={phone}
                          placeholder=" "
                          onChangeText={(text) => setValue(text)}
                          onChangeCountry={(text) => setValueCode(text.callingCode[0])}
                          autoFocus={true}
                          containerStyle={{
                            width: 50,
                          }}
                          textContainerStyle={{
                            backgroundColor: "transparent",
                            paddingLeft: 0,
                          }}
                          codeTextStyle={{
                            fontSize: 16,
                            fontFamily: "montserrat-regular",
                            color: "#2f7185",
                          }}
                          layout={"second"}
                          textInputStyle={{
                            ...Platform.select({
                              web: {
                                outlineStyle: 'none'
                              }
                            }), 
                            fontSize: 16,
                            fontFamily: "montserrat-regular",
                            height: 40,
                            width: 180,
                          }}
                          flagButtonStyle={{
                            width: 60,
                          }}
                        />
                      </View>
                    ) : (
                        <View style={styles.flexStyle}>
                          <Text style={styles.formLabelStyle}>Phone</Text>
                          <IntlPhoneInput
                            onChangeText={onChangePhoneText}
                            ref={(ref) => (phoneInput = ref)}
                            customModal={renderCustomModal}
                            defaultCountry="AU"
                            placeholder=""
                            containerStyle={{
                              flex: 3,
                            }}
                            flagStyle={{ display: "none" }}
                            // filterInputStyle={styles.textInput}
                            dialCodeTextStyle={{
                              fontSize: 16,
                              fontFamily: "montserrat-regular",
                              color: "#2f7185",
                            }}
                            phoneInputStyle={{
                              fontSize: 16,
                              fontFamily: "montserrat-regular",
                            }}
                            modalCountryItemCountryNameStyle={{
                              color: "black",
                              // flagStyle: { display: "none" },
                            }}
                          />
                        </View>
                      )}
                  </View>
                  {/* <Text>{JSON.stringify(phone)}</Text> */}
                </View>
              ) : (
                  <></>
                )}

              {refId != "null" ? (
                /* Referall section */
                // <View style={styles.inputContainer}>
                //   {/* <Text>{parsedUrl.searchParams.get("refId")}</Text> */}
                //   <TextInput
                //     style={styles.textInput}
                //     placeholder="Referral Code (optional)"
                //     placeholderTextColor="#adb4bc"
                //     keyboardType={"default"}
                //     returnKeyType="next"
                //     autoCapitalize="none"
                //     autoCorrect={false}
                //     secureTextEntry={false}
                //     value={refId}
                //     onChangeText={(text) => onChangeRefIDText(text)}
                //     dialCodeTextStyle={styles.textInput}
                //   />
                // </View>
                <></>
              ) : (
                  <></>
                )}
              {/*  password section  */}
              <View style={styles.PasswordinputContainer}>
                <View style={styles.Passwordinput}>
                  <TextInput
                        style={styles.textInput}
                        placeholder="Create Password"
                        placeholderTextColor="#adb4bc"
                        returnKeyType="next"
                        autoCapitalize="none"
                        autoCorrect={false}
                        secureTextEntry={showHidePassword}
                        value={password}
                        onChangeText={(text) => onChangePassText(text)}
                      />
                </View>
                <View style={styles.PasswordToggle}>
                  <TouchableOpacity
                    style={styles.iconContainer}
                    onPress={() =>
                      showHidePassword
                        ? onChangePasswordShow(false)
                        : onChangePasswordShow(true)
                    }
                  >
                    {showHidePassword ? (
                      <AntDesign color="#aaaaaa" name="eyeo" size={20} />
                    ) : (
                      <AntDesign color="#aaaaaa" name="eye" size={20} />
                    )}
                  </TouchableOpacity>
                </View>
              </View>
              <Text style={styles.TextStylePassword}>
                At least 8 Characters.
              </Text>
              <Text style={styles.TextStylePassword}>
                (With 1 letter and 1 number.)
              </Text>
            </View>
            {platform === "web" ? (
            <TouchableOpacity
              style={styles.SubmitButtonStyle}
              onPress={() => {
              var myphone = "";
              var un = "";
              if (platform === "web") {
                un = value;
                if (un.charAt(0) == '0') un = un.substring(1);
                un = "+" + valueCode + un;
              } else {
                un = phone.unmaskedPhoneNumber;
                if (un != undefined) {
                  if (un.charAt(0) == "0") un = un.substring(1);
                  un = phone.dialCode.concat(un);  
                } else {
                  un = "";
                }
              }
              var myphone = un;
                trySignUp(
                  formMode,
                  password,
                  email,
                  givenName,
                  familyName,
                  myphone,
                  refId
                );
              }}
            >
              <Text style={styles.TextStyle}>CONTINUE</Text>
            </TouchableOpacity>
        ) : (
          <></>
        ) }
              <Text style={styles.TextStyleError}>{errorMsg}</Text>
          </View>
          </ScrollView>
          </>
      ) : (
          <></>
        )}
      {step === 1 ? (
        <>
          <View style={styles.padThirty}>
            <View style={styles.HbuttonBar}>
              <View style={styles.HbackButtonStyle}></View>
              <View>
                <Text style={styles.HTextStyle}>REGISTER</Text>
              </View>
              <View style={styles.HbackButtonStyle}></View>
            </View>
            <View style={styles.modalContainerF}>
              <View style={styles.modalContainer}>
                <View>
                  <View style={GlobalStyles.headerTextP}>
                    <View style={GlobalStyles.headingStyle}>
                      <Text style={styles.textStyleHeader}>
                        Aura verification...
                      </Text>
                      <Text style={styles.textStyleBody}>
                        A verification code has been sent to your phone/email.
                      </Text>
                      <TouchableOpacity
                        style={styles.MSubmitButtonStyle}
                        activeOpacity={0.5}
                        onPress={async () => {
                          onChangeStep(2);
                        }}
                      >
                        <Text style={styles.MtextStyle}>OK</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>
              <Image style={styles.sparkle} source={sparkle} />
            </View>
          </View>
        </>
      ) : (
          <></>
        )}
      {
        /* code confirmation section  */
        step === 2 ? (
          <>
            <View style={styles.headerContainerJoin}>
              <View style={styles.HbuttonBarConf}>
                <TouchableOpacity
                  style={styles.HbackButtonStyle}
                  //onPress={() => navigation.goBack()}
                  onPress={() => navigation.popToTop()}
                >
                  <Ionicons
                    name="md-arrow-back"
                    size={20}
                    style={styles.HbackArrowBlack}
                  />
                </TouchableOpacity>
                <View>
                  <Text style={styles.HTextStyle}></Text>
                </View>
                <View style={styles.HbackButtonStyle}></View>
              </View>

              <View style={styles.infoBoxB}>
                <Text style={styles.TextStyleVerificationHeader}>
                  Verification Code
                </Text>
                <Text style={styles.textStyleBodyCenter}>
                  Check your email/phone for the verification code.
                </Text>
                <View style={styles.inputContainer}>
                  <TextInput
                    style={styles.textInputConf}
                    placeholder="Enter code"
                    placeholderTextColor="#adb4bc"
                    keyboardType={"numeric"}
                    returnKeyType="done"
                    autoCapitalize="none"
                    autoCorrect={false}
                    secureTextEntry={false}
                    value={authCode}
                    onChangeText={(text) => onChangeAuthCodeText(text)}
                    autoComplete="one-time-code"
                  />
                </View>
              </View>
              <TouchableOpacity
                style={styles.SubmitButtonStyleNone}
                onPress={async () => {
                
                  var un = "";
                  if (
                    formMode === "p" //&&
                   // phone.unmaskedPhoneNumber !== undefined
                  ) {
                    if (platform === "web") {
                      un = value;
                      if (un.charAt(0) == '0') un = un.substring(1);
                      un = "+" + valueCode + un;
                    } else {
                      un = phone.unmaskedPhoneNumber;
                      if (un.charAt(0) == "0") un = un.substring(1);
                      un = phone.dialCode.concat(un);
                    }
                  } else if (formMode === "e" && email !== "") un = email;
                  await Auth.resendSignUp(un);
                }}
              >
                <Text style={styles.TextStyleResend}>RESEND CODE</Text>
              </TouchableOpacity>
            </View>
            <TouchableOpacity
              style={styles.SubmitButtonStyleConfirm}
              onPress={() => {
                var un = "";
                if (
                  formMode === "p" //&&
                  //phone.unmaskedPhoneNumber !== undefined
                ) {
                  if (platform === "web") {
                    un = value;
                    if (un.charAt(0) == '0') un = un.substring(1);
                    un = "+" + valueCode + un;
                  } else {
                    un = phone.unmaskedPhoneNumber;
                    if (un.charAt(0) == "0") un = un.substring(1);
                    un = phone.dialCode.concat(un);
                  }
                } else if (formMode === "e" && email !== "") un = email;
                else {
                  onErrorMsg("Phone or Email Required");
                  return;
                }
                // onErrorMsg(un);
                confirmSignUp(un, authCode, formMode);
              }}
            >
              <Text style={styles.TextStyle}>CONFIRM</Text>
            </TouchableOpacity>
          </>
        ) : (
            <></>
          )
      }
    </View>
  );
}

const styles = StyleSheet.create({
  phoneModalSafeArea: {
    //backgroundColor: 'blue',
    height: "100%",
  },

  phoneModalContainer: {
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 48,
  },

  phoneModalClose: {
    alignItems: "flex-start",
    justifyContent: "center",
    marginBottom: 20,
    height: 40,
    paddingLeft: 5,
  },

  phoneModalIcon: {
    paddingLeft: 5,
  },

  phoneModalText: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 18,
  },

  phoneModalInputContainer: {
    flexDirection: "row",
  },

  phoneModalInputField: {
    color: "#000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 18,
    marginBottom: 20,
    width: "100%",
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    paddingBottom: 5,
  },

  phoneModalList: {
    height: "80%",
  },

  phoneModalListItem: {
    flexDirection: "row",
    //marginBottom: 20,
    alignItems: "center",
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    paddingBottom: 10,
    paddingTop: 10,
  },

  phoneModalListItemFlag: {
    //flex:2,
    width: 60,
  },
  phoneModalListIemFlagText: {
    fontSize: 22,
  },

  phoneModalListItemCountry: {
    flex: 15,
  },

  phoneModalListItemDailcode: {
    flex: 1,
    minWidth: 30,
  },

  phoneModalListIemText: {
    color: "#000",
    fontFamily: "montserrat-regular",
    fontSize: 15,
  },

  padThirty: {
    paddingTop: 45,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
    //maxWidth: 450,
  },

  headerContainerJoin: {
    height: 300,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 50,
    borderBottomColor: "#dddddd",
    borderBottomWidth: 1,
    borderLeftColor: "#dddddd",
    borderLeftWidth: 1,
  },

  TextStyleVerificationHeader: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    marginBottom: 20,
  },

  TextStyleResend: {
    padding: 5,
    fontSize: 12,
    color: "#337599",
    fontWeight: "bold",
    textAlign: "center",
  },

  SubmitButtonStyleNone: {
    marginTop: 0,
    marginLeft: 50,
    marginRight: 50,
    //paddingTop: 22,
    //paddingBottom: 25,
    borderRadius: 50,
    justifyContent: "center",
    height: 30,
  },

  modalContainer: {
    height: 200,
    backgroundColor: "#FFC72C",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 60,
    borderTopLeftRadius: 60,
    borderTopRightRadius: 60,
    marginLeft: 15,
    marginRight: 15,
    paddingTop: 30,
    width: 300,
    alignSelf: "center",
  },
  modalContainerF: {
    marginTop: 150,
    paddingTop: 20,
    marginLeft: 0,
    marginRight: 0,
  },

  textStyleHeader: {
    color: "#fff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 16,
    marginLeft: -15,
    marginBottom: 20,
  },

  textStyleBody: {
    color: "#000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    marginLeft: -15,
  },

  textStyleBodyCenter: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    marginLeft: -15,
  },

  MtextStyle: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 16,
  },
  sparkle: {
    position: "absolute",
    top: 0,
    right: -15,
  },

  HbuttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
  },

  HbuttonBarConf: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    marginTop: 30,
    marginLeft: 30,
    marginRight: 30,
  },

  HbackArrow: {
    color: "#fff",
  },

  HbackArrowBlack: {
    color: "#000",
  },

  HbackButtonStyle: {
    marginTop: 0,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },


  HbackButtonStyleB: {
    marginTop: 5,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },

  LinkBarNext: {
    width: "52%",
    height: 4,
    backgroundColor: "#FFC72C",
    alignSelf: "flex-end",
    marginTop: 10,
    marginBottom: 0,
  },


  HTextStyle: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },

  container: {
    //paddingTop: 15,
  },
  
  containerOne: {
    //paddingBottom: 500,
   // backgroundColor: "red",
    //minHeight:  600,
   // height:600,
  },

  containerX: {
    //backgroundColor: 'red',
    // justifyContent: 'flex-start',
    // flex: 1,
  },

  infoBox: {
    height: 320,
    width: 350,
    backgroundColor: "#ffffff",
    borderRadius: 15,
    marginBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
    paddingTop: 5,
    alignSelf: "center",
  },

  infoBoxB: {
    width: 350,
    backgroundColor: "#ffffff",
    borderRadius: 15,
    marginBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
    paddingTop: 5,
    alignSelf: "center",
  },

  input: {
    flex: 0,
    fontSize: 17,
    fontWeight: "bold",
    color: "#fff",
    backgroundColor: "#444",
  },
  infoContainer: {
    //   position: 'absolute',
    left: 0,
    right: 0,
    height: 370,
    //   bottom: 25,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 30,
    // backgroundColor: '#5059ae',
  },
  itemStyle: {
    marginBottom: 10,
  },
  flexStyle: {
    flex: 1,
    flexDirection: "row",
  },
  iconStyle: {
    color: "#fff",
    fontSize: 28,
    marginRight: 15,
  },
  buttonStyle: {
    alignItems: "center",
    backgroundColor: "#b44666",
    padding: 14,
    marginBottom: 10,
    borderRadius: 3,
  },

  TextStyleVerification: {
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    paddingTop: 20,
    fontFamily: "montserrat-regular",
  },

  buttonText: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#fff",
  },
  logoContainer: {
    position: "absolute",
    left: 0,
    right: 0,
    height: 600,
    bottom: 270,
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },

  countryStyle: {
    flex: 1,
    backgroundColor: "#5059ae",
    borderTopColor: "#211f",
    borderTopWidth: 1,
    padding: 12,
  },
  closeButtonStyle: {
    flex: 1,
    padding: 12,
    alignItems: "center",
    backgroundColor: "#b44666",
  },

  inputContainer: {
    paddingTop: 15,
  },

  textInput: {
    ...Platform.select({
      web: {
        outlineStyle: 'none'
      }
    }),
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
  },

  textInputNoUnderline: {
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
    // flex: 1,
    // flexDirection: "row"
  },

  formLabelStyle: {
    color: "#aaaaaa",
    textAlign: "center",
    textAlignVertical: "center",
    fontFamily: "montserrat-regular",
    fontSize: 15,
    paddingRight: 20,
    paddingTop: 8,
    borderColor: "#CCCCCC",
    // borderBottomWidth: 1,
  },

  textInputConf: {
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 30,
    paddingRight: 20,
    textAlign: "center",
    fontFamily: "montserrat-regular",
  },

  TextStyle: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },

  TextStyleRight: {
    color: "#ffffff",
    textAlign: "right",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },

  MSubmitButtonStyle: {
    marginTop: 20,
    marginLeft: -15,
    //paddingTop: 22,
    //paddingBottom: 25,
    backgroundColor: "#ffffff",
    borderRadius: 50,
    width: "50%",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    height: 60,
  },

  SubmitButtonStyle: {
    marginTop: 0,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
    justifyContent: "center",
    width: 350,
    alignSelf: "center",
  },

  SubmitButtonStyleConfirm: {
    marginTop: 30,
    marginLeft: 120,
    marginRight: 120,
    paddingTop: 22,
    paddingBottom: 25,
    backgroundColor: "#337599",
    borderRadius: 50,
    justifyContent: "center",
    height: 60,
  },

  TextStyleError: {
    color: "#FFFFFF",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 16,
    paddingTop: 20,
  },

  TextStylePassword: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    paddingTop: 3,
  },

  PasswordinputContainer: {
    paddingTop: 15,
    flexDirection: "row",
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
  },

  iconContainer: {
    //paddingLeft: 0,
    //paddingRight: 30,
    paddingTop: 10,
    //width: 50,
  },

  Passwordinput: {
    flex:7,
  },

  PasswordToggle: {
    flex:1,
    paddingLeft: 45,
    paddingRight: 0,
    //paddingTop: 10,
  },
});
